export const USERNAME_HELP_TEXT = 'Korisničko ime ne smije sadržavati razmake.';

export function validateUsername(username) {
  if (!username) {
    return 'Korisničko ime je obavezno.';
  }

  if (/\s/.test(username)) {
    return USERNAME_HELP_TEXT;
  }

  return null;
}
